// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * LCC API
 * API for the LCC backend
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface LADSDeviceStateMachine
 */
export interface LADSDeviceStateMachine {
    /**
     * 
     */
    currentState: LADSDeviceStateMachineCurrentStateEnum;
    /**
     * 
     */
    lastTransition?: LADSDeviceStateMachineLastTransitionEnum;
    /**
     * OPC UA StatusCode name of the CurrentState read (e.g. "Good", "UncertainNoCommunicationLastUsableValue"). Drives online/offline independently of the operational currentState.
     */
    statusCode?: string;
}


/**
 * @export
 */
export const LADSDeviceStateMachineCurrentStateEnum = {
    Initialization: 'initialization',
    Operate: 'operate',
    Sleep: 'sleep',
    Shutdown: 'shutdown'
} as const;
export type LADSDeviceStateMachineCurrentStateEnum = typeof LADSDeviceStateMachineCurrentStateEnum[keyof typeof LADSDeviceStateMachineCurrentStateEnum];

/**
 * @export
 */
export const LADSDeviceStateMachineLastTransitionEnum = {
    InitializationToOperate: 'initializationToOperate',
    OperateToSleep: 'operateToSleep',
    SleepToOperate: 'sleepToOperate',
    OperateToShutdown: 'operateToShutdown'
} as const;
export type LADSDeviceStateMachineLastTransitionEnum = typeof LADSDeviceStateMachineLastTransitionEnum[keyof typeof LADSDeviceStateMachineLastTransitionEnum];


/**
 * Check if a given object implements the LADSDeviceStateMachine interface.
 */
export function instanceOfLADSDeviceStateMachine(value: object): value is LADSDeviceStateMachine {
    if (!('currentState' in value) || value['currentState'] === undefined) return false;
    return true;
}

export function LADSDeviceStateMachineFromJSON(json: any): LADSDeviceStateMachine {
    return LADSDeviceStateMachineFromJSONTyped(json, false);
}

export function LADSDeviceStateMachineFromJSONTyped(json: any, ignoreDiscriminator: boolean): LADSDeviceStateMachine {
    if (json == null) {
        return json;
    }
    return {
        
        'currentState': json['currentState'],
        'lastTransition': json['lastTransition'] == null ? undefined : json['lastTransition'],
        'statusCode': json['statusCode'] == null ? undefined : json['statusCode'],
    };
}

export function LADSDeviceStateMachineToJSON(json: any): LADSDeviceStateMachine {
    return LADSDeviceStateMachineToJSONTyped(json, false);
}

export function LADSDeviceStateMachineToJSONTyped(value?: LADSDeviceStateMachine | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'currentState': value['currentState'],
        'lastTransition': value['lastTransition'],
        'statusCode': value['statusCode'],
    };
}

